import _ from 'lodash';
import { LngLat } from 'mapbox-gl';
import { computed } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useLeadStore } from '../..';
import useLeadsWithFocusArea from '../../hooks/useLeadsWithFocusArea';
import useLeadsWithGlobalFilters from '../../hooks/useLeadsWithGlobalFilters';
import useProperty from '../../hooks/useProperty';
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import LeadsGrid from '../leads/LeadsGrid';

function PropertyDetailsLeadsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { longitude, latitude } = useParams();
    const leadStore = useLeadStore();
    const coordinates = useMemo(() => new LngLat(Number(longitude), Number(latitude)), [longitude, latitude]);
    const property = useProperty(coordinates).property!;
    const leads = useLeadsWithFocusArea(useLeadsWithGlobalFilters(useMemo(() => computed(() => {
        return leadStore.leads.filter(l =>
            (l.ownerAddress && property.ownerAddress) && _.isEqual(l.ownerAddress.replace(/,/gm, "").toLowerCase(), property.ownerAddress.toLowerCase()) ||
            (l.ownerName && property.ownerEntity) && _.isEqual(l.ownerName.toLowerCase(), property.ownerEntity.toLowerCase()));
    }), [property]).get()));

    useEffect(() => setEntityCount(leads.length), [leads]);

    if (!visible)
        return null;

    return <LeadsGrid leads={leads} />;
}

export default observer(PropertyDetailsLeadsTab);